'use strict';

angular.module('myConsultApp').factory('PetsService', function ($resource, ENV, Session) {
    var petsService = {};

    petsService.getPetsByOrganization = function (organizationId) {
        var pets = $resource(
            ENV.apiEndpoint + '/1.0/pets/',
            {},
            { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } }
        );

        return pets.get({ organization: organizationId }).$promise.then(function (response) {
            return response.pets;
        });
    };

    petsService.getPetProfile = function (id) {
        var pet = $resource(
            ENV.apiEndpoint + '/1.0/pets/:id/',
            { id: id },
            { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } }
        );

        return pet.get().$promise.then(function (response) {
            return response.pet;
        });
    };

    petsService.getProPetProfile = function (id, owner_id) {
        var pet = $resource(
            ENV.apiEndpoint + '/1.0/pets/:id/?owner=' + owner_id,
            { id: id },
            { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } }
        );

        return pet.get().$promise.then(function (response) {
            return response.pet;
        });
    };

    petsService.createdProPet = function (pet) {
        var newPet = $resource(
            ENV.apiEndpoint + '/1.0/pets/',
            {},
            {
                save: {
                    method: 'POST',
                    headers: { Authorization: 'Bearer ' + Session.accessToken }
                }
            }
        );

        return newPet.save(pet).$promise.then(function (response) {
            return response;
        });
    };

    petsService.updateProPetProfile = function (id, owner_id, data) {
        var pet = $resource(
            ENV.apiEndpoint + '/1.0/pets/:id/?owner=' + owner_id,
            { id: id },
            {
                update: {
                    method: 'PUT',
                    headers: { Authorization: 'Bearer ' + Session.accessToken }
                }
            }
        );

        return pet.update(data).$promise.then(function (response) {
            return response;
        });
    };

    petsService.updatePetProShelter = function (petId, providerData) {
        var organizations;
        organizations = $resource(
            ENV.apiEndpoint +
                '/1.0/pets/:petId/providers/' +
                providerData.petProvider.relation_type +
                '/',
            { petId: petId },
            {
                save: {
                    method: 'PUT',
                    headers: { Authorization: 'Bearer ' + Session.accessToken }
                }
            }
        );

        return organizations.save(providerData).$promise.then(function (response) {
            return response;
        });
    };

    petsService.getPetsByOwnerOrg = function (id, organization) {
        var pets = $resource(
            ENV.apiEndpoint + '/1.0/pets/',
            {},
            {
                get: {
                    headers: { Authorization: 'Bearer ' + Session.accessToken }
                }
            }
        );

        return pets
            .get({ owner: id, organization: organization })
            .$promise.then(function (response) {
                return response;
            });
    };

    petsService.getPetOwner = function (id, order) {
        var pets = $resource(
            ENV.apiEndpoint + '/1.0/pets/',
            {},
            {
                get: {
                    headers: { Authorization: 'Bearer ' + Session.accessToken }
                }
            }
        );

        return pets.get({ owner: id, order: order }).$promise.then(function (response) {
            return response;
        });
    };

    petsService.getBreeds = function (species) {
        species = typeof species !== 'undefined' ? species : '';
        var pet = $resource(
            ENV.apiEndpoint + '/1.0/breeds/',
            {},
            {
                get: {
                    cache: true,
                    method: 'get',
                    headers: { Authorization: 'Bearer ' + Session.accessToken }
                }
            }
        );
        var jsonSpecies = species !== '' ? { species: species } : {};

        return pet.get(jsonSpecies).$promise.then(function (response) {
            return response;
        });
    };

    petsService.updatePet = function (id, petInfo) {
        var pet = $resource(
            ENV.apiEndpoint + '/1.0/pets/:id/',
            { id: id },
            {
                update: {
                    method: 'PUT',
                    headers: { Authorization: 'Bearer ' + Session.accessToken }
                }
            }
        );

        return pet.update(petInfo).$promise.then(function (response) {
            return response;
        });
    };

    petsService.getPetHealthDict = function (id) {
        var pet = $resource(
            ENV.apiEndpoint + '/1.0/pets-health/:id/',
            { id: id },
            {
                get: {
                    method: 'GET',
                    headers: { Authorization: 'Bearer ' + Session.accessToken }
                }
            }
        );
        return pet.get().$promise.then(function (response) {
            return response;
        });
    };

    petsService.getPetHealthData = function (id, category, slug) {
        var pet = $resource(
            ENV.apiEndpoint + '/1.0/pets-health/:id/:category/:slug/',
            { id: id, category: category, slug: slug },
            {
                get: {
                    method: 'GET',
                    headers: { Authorization: 'Bearer ' + Session.accessToken }
                }
            }
        );
        return pet.get().$promise.then(function (response) {
            return response;
        });
    };

    return petsService;
});
